import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import ReactGA from "react-ga4";

import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from "react-router-dom";
ReactGA.initialize("G-16EYZ4MT6K");
ReactGA.send({ hitType: 'pageview', page: window.location.pathname });

ReactDOM.render(
<BrowserRouter>
    <App />
</BrowserRouter>,
  document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
